import { styled } from 'parkdepot-shared/theme'

export const Container = styled<'div', { $displayedLots?: boolean }>('div', ({ $theme, $displayedLots = false }) => ({
    color: $theme.colors.contentAccent,
    backgroundColor: $theme.colors.white
}))

export const StartWrapper = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginBottom: '1.6rem',
    [$theme.mediaQuery.large]: {}
}))

export const NoAvailableLotsContainer = styled('div', ({ $theme }) => ({
    // border: '1px dashed #b3bbc7',
    padding: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '8rem',
    cursor: 'pointer',
    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='14' ry='14' stroke='gray' stroke-width='1' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");border-radius: 14px;`
}))

export const NoLotsIcon = styled('i', ({ $theme }) => ({
    fontSize: '3.2rem',
    color: $theme.colors.primary
}))

export const NoLotsText = styled('span', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    color: $theme.colors.primary,
    fontWeight: 700
}))

export const Subtitle = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingSmall,
    fontWeight: 700,
    margin: 0
}))

export const HiddenContainer = styled('div', () => ({
    display: 'none'
}))
